var r;!function(r){r.SQUARE="square",r.ROUND="round",r.UNDERLINE="underline"}(r||(r={}));var a={layout:"",primary:"Search",secondary:"Clear Search"};export{a as SearchDefaultIconNames,r as SearchType};
//# sourceMappingURL=SearchConstants.js.map
